const solutionStatus = [
	"init-solution",
	"pre-active-solution",
	"active-solution",
	"post-active-solution",
	"post-post-active-solution",
	"post-post-post-active-solution",
	"end-solution",
];

let solutions;
let currentSolution;

const setInitPosSolution = () => {
	let initSolution = (currentSolution - 2) % solutions.length;
	if (initSolution < 0) initSolution += solutions.length;
	solutions[initSolution].classList.remove(solutionStatus[1]);
	solutions[initSolution].classList.add(solutionStatus[0]);
};

const setPostInitSolution = () => {
	let postSolution = (currentSolution - 1) % solutions.length;
	if (postSolution < 0) postSolution += solutions.length;
	solutions[postSolution].classList.remove(solutionStatus[2]);
	solutions[postSolution].classList.add(solutionStatus[1]);
};

const setCurrentPosSolution = () => {
	let current = currentSolution % solutions.length;
	solutions[current].classList.remove(solutionStatus[3]);
	solutions[current].classList.add(solutionStatus[2]);
};

const setPreEndSolution = () => {
	let preSolution = (currentSolution + 1) % solutions.length;
	solutions[preSolution].classList.remove(solutionStatus[4]);
	solutions[preSolution].classList.add(solutionStatus[3]);
};

const setPostPostEndSolution = () => {
	let postPostSolution = (currentSolution + 2) % solutions.length;
	solutions[postPostSolution].classList.remove(solutionStatus[5]);
	solutions[postPostSolution].classList.add(solutionStatus[4]);
};

const setPostPostPostEndSolution = () => {
	let postPostPostSolution = (currentSolution + 3) % solutions.length;
	solutions[postPostPostSolution].classList.remove(solutionStatus[6]);
	solutions[postPostPostSolution].classList.add(solutionStatus[5]);
};

const setEndPosSolution = () => {
	let endSolution = (currentSolution + 4) % solutions.length;
	solutions[endSolution].classList.remove(solutionStatus[0]);
	solutions[endSolution].classList.add(solutionStatus[6]);
};

const setCurrentSolution = () => {
	setInitPosSolution();
	setPostInitSolution();
	setCurrentPosSolution();
	setPreEndSolution();
	setPostPostEndSolution();
	setPostPostPostEndSolution();
	setEndPosSolution();
	currentSolution++;
};

const seoListSolutions = () => {
	const listSolutions = document.querySelector(".seo__solutions-list");
	if (!listSolutions) return;

	solutions = listSolutions.querySelectorAll(".seo__solutions-list > .wp-block-group");

	if (!solutions || solutions.length === 0) return;
	currentSolution = solutions.length;
	setCurrentSolution();
	setInterval(setCurrentSolution, 3000);
};

export { seoListSolutions };
